import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { ProductContextFacade } from 'ish-core/facades/product-context.facade';

@Component({
  selector: 'ish-product-master-link',
  templateUrl: './product-master-link.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ProductContextFacade],
  imports: [AsyncPipe, RouterModule, TranslateModule],
})
export class ProductMasterLinkComponent implements OnInit {
  masterProductURL$: Observable<string>;
  visible$: Observable<boolean>;

  private parentContext: ProductContextFacade = inject(ProductContextFacade, { skipSelf: true });
  private context: ProductContextFacade = inject(ProductContextFacade);

  ngOnInit() {
    this.context.connect('sku', this.parentContext.select('product', 'productMasterSKU'));
    this.visible$ = this.parentContext.select('displayProperties', 'variations');

    this.masterProductURL$ = this.context.select('productURL');
  }
}
